export const SET_USER_SETTINGS_STATE = "SET_USER_SETTINGS_STATE";
export const SET_LOGIN_DETAILS_STATE = "SET_LOGIN_DETAILS_STATE";
export const SET_LOGIN_STATE = "SET_LOGIN_STATE";
export const SET_MODAL_STATE = "SET_MODAL_STATE";
export const SET_TIME_ZONE_SETTINGS_STATE = "SET_TIME_ZONE_SETTINGS_STATE";
export const SET_SELECTION_STATE = "SET_SELECTION_STATE";
export const SET_SOCCER_MATCHES_STATE = "SET_SOCCER_MATCHES_STATE";
export const SET_SOCCER_LEAGUES_STATE = "SET_SOCCER_LEAGUES_STATE";
export const SET_FILTER = "SET_FILTER";